import React from 'react';

const PrivacyPolicyMeriastro = () => {
    return (
        <div className="min-h-screen bg-dark pt-24 pb-16">
            <div className="max-w-screen-md mx-auto px-6">
                <h1 className="text-3xl font-custom1 text-white mb-6">Privacy Policy</h1>

                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    This Privacy Policy describes how Meriastro ("we", "us", or "our") collects, uses, and shares information about you when you use our mobile application.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Information We Collect</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We collect the following information when you use our app:
                </p>
                <ul className="list-disc ml-6 mb-6 text-gray-300 font-custom2">
                    <li><strong className="text-white">Email Address</strong></li>
                    <li><strong className="text-white">Password</strong></li>
                    <li><strong className="text-white">Date of Birth</strong></li>
                    <li><strong className="text-white">Username</strong></li>
                    <li><strong className="text-white">Device ID</strong></li>
                </ul>

                <h2 className="text-2xl font-custom1 text-white mb-4">How We Use Your Information</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    The information we collect is used for the following purposes:
                </p>
                <ul className="list-disc ml-6 mb-6 text-gray-300 font-custom2">
                    <li>To personalize astrology and spiritual content based on user profile.</li>
                    <li>To provide access to premium and personalized features.</li>
                    <li>To analyze how users interact with the app for continuous improvement.</li>
                    <li>To ensure secure access and manage user accounts effectively.</li>
                </ul>

                <h2 className="text-2xl font-custom1 text-white mb-4">Data Sharing</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We do not share your personal information with third-party advertisers. Limited information may be shared with analytics providers to help us improve Meriastro's features and performance.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Data Retention</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We retain your information as long as your account is active or as needed to provide you with our services. You may request deletion of your account at any time.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">User Control & Account Deletion</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    Users may request account deletion via email. Upon request, your profile and all associated data will be permanently deleted from our systems. To request deletion, contact us at <a href="mailto:samedakgul99@gmail.com" className="text-accent-orange hover:underline">samedakgul99@gmail.com</a>.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Children's Privacy</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    Meriastro is not intended for children under the age of 13. We do not knowingly collect data from children. If such data is inadvertently collected, we will take steps to delete it promptly upon notice.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Updates to This Privacy Policy</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We may update this Privacy Policy from time to time. Significant changes will be communicated within the app or via app store updates.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Contact Information</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us at:
                    <br />
                    Email: <a href="mailto:samedakgul99@gmail.com" className="text-accent-orange hover:underline">samedakgul99@gmail.com</a>
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicyMeriastro;
